import { isEmpty } from 'lodash'
import { Installation } from 'src/Libs/installations/models/installation.model'
import { UserType } from 'src/Libs/user/types'
import { CHANGE_EMAIL_QUERY_PARAM, GIFT_CODE_QUERY_TOKEN_PARAM, TOKEN_QUERY_PARAM } from '../consts'
import { InstallationOverviewPage } from '../types'
import { getInstallationDashboardUrl } from 'src/Libs/dashboard/routes'

/**
 * Function that returns the entry path for a specific user
 *
 * @param installations - fetched user installations
 * @param installationCount -fetched installations amount
 * @param userType - portal user type
 */
export const getEntryPathForUserType = (installations: Installation[], installationCount: number, userType?: UserType): string | undefined => {
  if (userType === 'OWNER') {
    if (!isEmpty(installations) && installationCount === 1) {
      return getInstallationDashboardUrl(installations[0])
    } else {
      return '/dashboard/overview/'
    }
  }

  if (userType === 'INSTALLATION_OVERVIEW') return InstallationOverviewPage.Overview
  if (userType === 'INSTALLER_PARTNER' || userType === 'COMPANY_OWNER') return InstallationOverviewPage.InstallerDashboard
  if (userType === 'SERVICE') return InstallationOverviewPage.Installations
  return undefined
}

/**
 * Get a url search parameter as string for invitation or change email tokens
 * @param invitationToken
 * @param changeEmailToken
 */
export const getTokenEntryPath = (
  invitationToken: string | null,
  changeEmailToken: string | null,
  amazonCodeToken: string | null
): string | undefined => {
  if (invitationToken) {
    return `${TOKEN_QUERY_PARAM}=${invitationToken}`
  }
  if (changeEmailToken) {
    return `${CHANGE_EMAIL_QUERY_PARAM}=${changeEmailToken}`
  }
  if (amazonCodeToken) {
    return `${GIFT_CODE_QUERY_TOKEN_PARAM}=${amazonCodeToken}`
  }
  return undefined
}

interface GetEntryPointPath {
  installations: Installation[]
  installationCount: number
  userType?: UserType
  invitationToken: string | null
  changeEmailToken: string | null
  amazonCodeToken: string | null
}

/**
 * A function to get a url for a specific user when visiting the default path "/"
 */
export const getEntryPointPath = ({
  installations,
  installationCount,
  userType,
  invitationToken,
  changeEmailToken,
  amazonCodeToken,
}: GetEntryPointPath): string | undefined => {
  const userEntryPath = getEntryPathForUserType(installations, installationCount, userType)
  const tokenEntryPath = getTokenEntryPath(invitationToken, changeEmailToken, amazonCodeToken)

  if (userEntryPath) {
    const newTarget: string[] = []
    newTarget.push(userEntryPath)
    if (tokenEntryPath) newTarget.push(tokenEntryPath)
    return newTarget.join('?')
  }

  return undefined
}
